import React, { type ReactNode } from 'react';

import { Card, Row } from 'antd';
import { useAppSelector } from 'services/redux/configureStore';

import styles from './Card.module.css';
import { Field, type CardField } from '../ui/Field';

export interface SimpleCardProps {
  title: string;
  headerPanel?: ReactNode;
  fields: CardField[];
}

export const SimpleCard = ({ title, fields, headerPanel }: SimpleCardProps) => {
  const isDarkMode = useAppSelector((state) => state.theme.isDarkMode);

  return (
    <Card
      bordered={false}
      className={`${styles.card} ${isDarkMode ? styles.card_dark : ''}`}
      title={
        headerPanel ? (
          <Row justify="space-between">
            <div>{title}</div>
            <div>{headerPanel}</div>
          </Row>
        ) : (
          <>{title}</>
        )
      }
    >
      {fields.map((field) => (
        <Field key={field.label} isEditing={false} {...field} />
      ))}
    </Card>
  );
};
